import { globalStyle, style } from '@vanilla-extract/css';
import { PlumaPage as PlumaPageCss } from '@customerio/pluma-components/css/components';
import { themeVars } from '@customerio/pluma-components/css/theme-tokens';

export const layoutContent = style(
  {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minWidth: 0,
  },
  'layout-content',
);

export const layoutContentInner = style(
  {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minWidth: 0,
    overflow: 'auto',
    transition: 'opacity 0.25s ease',
  },
  'layout-content-inner',
);

// Mirrors `ui/app/pods/application/index.css.ts` so Pluma `<Page>` content
// inside the embedded scroll container gets the same 950px min-width that
// Journeys/Ember pages get. Without this, the Page's 950px-min-width header
// and body center-overflow a narrower container and clip on the left.
globalStyle(`${layoutContentInner} .${PlumaPageCss.classNames.pageStandardWidth}`, {
  minWidth: PlumaPageCss.values.standardPageMinWidth,
});

export const layoutContentLayoutRefresh = style(
  {
    paddingRight: themeVars.space['150'],
    selectors: {
      '&::before, &::after': {
        content: '""',
        position: 'absolute',
        top: 0,
        width: themeVars.radius['10'],
        height: themeVars.radius['10'],
        pointerEvents: 'none',
        zIndex: 1,
      },
      '&::before': {
        left: 0,
        background: `radial-gradient(circle ${themeVars.radius['10']} at ${themeVars.radius['10']} ${themeVars.radius['10']}, transparent ${themeVars.radius['10']}, ${themeVars.color['navigation-background']} ${themeVars.radius['10']})`,
      },
      '&::after': {
        right: themeVars.space['150'],
        background: `radial-gradient(circle ${themeVars.radius['10']} at 0 ${themeVars.radius['10']}, transparent ${themeVars.radius['10']}, ${themeVars.color['navigation-background']} ${themeVars.radius['10']})`,
      },
    },
  },
  'layout-content-layout-refresh',
);

export const layoutContentInnerLayoutRefresh = style(
  {
    backgroundColor: themeVars.color['surface-base'],
    scrollbarWidth: 'thin',
  },
  'layout-content-inner-layout-refresh',
);
